module.exports = __webpack_public_path__ + "static/media/name.0efd3e06.png";